import { Getters } from 'vuex-smart-module';
import SubpartnersState from './state';

export default class SubpartnersGetters extends Getters<SubpartnersState> {}
